import { AppointmentExchangeResponse } from "@/api";
import { DataTable } from "@/common/components/table/DataTable";
import { ExchangeView } from "@/pages/exchange/Exchange.types";

import { useExchangeColumns } from "./hooks/useExchangeColumns";

const ROW_HEIGHT = 64;
const COLUMN_HEADER_HEIGHT = 56;

interface Props {
  rows: AppointmentExchangeResponse[];
  view: ExchangeView;
  isLoading: boolean;
  isBusy: boolean;
  paginationResetKey: string;
  onMakeOffer: (row: AppointmentExchangeResponse) => void;
  onWithdrawOffer: (row: AppointmentExchangeResponse) => void;
  onViewOffers: (row: AppointmentExchangeResponse) => void;
  onDeleteRequest: (row: AppointmentExchangeResponse) => void;
}

/**
 * Flat, sortable list of Tauschanfragen with alternating row shading; the column set follows the view.
 * In "Meine Anfragen" a click anywhere on the row opens the offers of that Anfrage.
 */
export function ExchangeTable({
  rows,
  view,
  isLoading,
  isBusy,
  paginationResetKey,
  onMakeOffer,
  onWithdrawOffer,
  onViewOffers,
  onDeleteRequest,
}: Props) {
  const columns = useExchangeColumns({ view, isBusy, onMakeOffer, onWithdrawOffer, onViewOffers, onDeleteRequest });

  const openOffersOfRow = (rowId: string) => {
    const row = rows.find((candidate) => candidate.id === rowId);
    if (row) {
      onViewOffers(row);
    }
  };

  return (
    <DataTable
      data={rows}
      columns={columns}
      getRowId={(row) => row.id}
      isLoading={isLoading}
      rowHeight={ROW_HEIGHT}
      columnHeaderHeight={COLUMN_HEADER_HEIGHT}
      initialSortModel={[{ field: "appointmentStartUtc", sort: "asc" }]}
      disableColumnMenu
      paginationResetKey={paginationResetKey}
      onRowClick={view === "mine" ? openOffersOfRow : undefined}
    />
  );
}
